import type { UptimeDay } from "@/lib/types";

interface Props {
  uptime: UptimeDay[];
  compact?: boolean;
  height?: number;
}

export function UptimeRibbon({ uptime, compact, height = 22 }: Props) {
  return (
    <div style={{ display: "flex", gap: 2, height, alignItems: "stretch" }}>
      {uptime.map((d, i) => {
        const c =
          d.state === "operational"
            ? "color-mix(in oklch, var(--success) 65%, transparent)"
            : d.state === "major" || d.state === "major-outage"
              ? "var(--destructive)"
              : d.state === "degraded"
                ? "var(--warning)"
                : "color-mix(in oklch, var(--warning) 80%, transparent)";
        return (
          <div
            key={i}
            title={`day -${uptime.length - 1 - i} · ${d.state}`}
            style={{
              flex: 1,
              background: c,
              borderRadius: 1.5,
              minWidth: 2,
              opacity: compact && i < uptime.length - 60 ? 0.7 : 1,
            }}
          />
        );
      })}
    </div>
  );
}
